import { SETTINGS_DEFAULT_SCREEN } from 'components/Settings/utils'
import { useHistory, useLocation } from 'react-router-dom'

export const useOpenSettings = () => {
  const history = useHistory()
  const location = useLocation()

  const openSettings = (screen = SETTINGS_DEFAULT_SCREEN) => {
    // eslint-disable-next-line no-restricted-properties
    const urlHash = window.location.hash
    const queryParams = new URLSearchParams(location.search)
    queryParams.set('settings', screen)

    // If there is a hash in the url (ie: content preferences page), we need to replace the state with the new path in order for the settings modal to open
    // eslint-disable-next-line no-restricted-properties
    const pathName = window.location.pathname
    const newPath = `${pathName}?${queryParams.toString()}${urlHash}`

    // eslint-disable-next-line no-restricted-properties
    window.history.replaceState(location.state, '', newPath)

    history.push({ search: queryParams.toString() })
  }

  return { openSettings }
}
